export { config as abstmolen } from '../../../projects/abstmolen/admin/config'
